import { IconMoodSmileBeam, IconMoodSad, IconX } from '@tabler/icons-react';
import { useSettingsStore, useAppStore } from '@stores';
import { FancyCard } from '@components/ui/FancyCard';
import { sendAppMessage } from '@helpers/mobileApp';
import { useTranslation } from 'react-i18next';

export function RateGame() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Hub.RateGame' });
  const { showRate, setShowRate } = useSettingsStore();
  const { userData, device, setTab } = useAppStore();

  if (!showRate) return null;
  if (!userData.tutorials.includes('Inv')) return null;

  const closeBanner = () => {
    setShowRate(false);
  };

  const writeInChat = () => {
    closeBanner();
    setTab('chat');
  };

  const leaveReview = () => {
    closeBanner();

    const url = device === 'ios' ?
      'https://apps.apple.com/us/app/battlechassis/id6743774807' :
      'https://play.google.com/store/apps/details?id=io.piktu.battlechassis';

    sendAppMessage('openLink', { url });
  };

  return (
    <FancyCard className="m-2">
      <div className="flex items-center justify-between">
        <p className="text-sm">{t('title')}</p>
        <button onClick={closeBanner}>
          <IconX className="mb-[2px]" size={20} />
        </button>
      </div>

      <div className="flex mt-2 text-sm">
        <button className="flex-1 py-2 btn-danger border mr-2 flex flex-col items-center justify-center" onClick={writeInChat}>
          <IconMoodSad size={22} />
          <p>{t('writeInChat')}</p>
        </button>

        <div className="flex-1 py-2 btn-active flex flex-col items-center justify-center py-2" onClick={leaveReview}>
          <IconMoodSmileBeam size={22} />
          <p>{t('rate')}</p>
        </div>
      </div>
    </FancyCard>
  );
}